export default __webpack_public_path__ + "static/media/4.4af41224.png";